<template>
  <div v-if="whistleblowerreport">
    <div
      v-if="!reportSent"
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2"
    ></div>
    <b-row v-if="!reportSent">
      <b-col md="12">
        <b-card
          :title="this.$t('whistleblowerReport.report.report')"
          border-variant="primary"
          header=" "
          header-bg-variant="primary"
          footer=" "
          footer-bg-variant="dark"
        >
          <b-card-text>
            <h1 v-if="error">{{ $t("whistleblowerReport.fieldsRequired") }}</h1>
            <div v-if="manualInvestigatorReport == true">
              <h3>{{ $t("addCompanyHere") }}</h3>
              <b-form-group :label="$t('Company Being Reported')" label-cols="4">
                <b-form-select v-model="whistleblowerreport.company">
                  <b-form-select-option
                    v-for="whistleblowingCompany in companyList"
                    :key="whistleblowingCompany.id"
                    :value="whistleblowingCompany"
                  >
                    {{ whistleblowingCompany.name }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <b-row class="my-2">
              <b-col md="12" class="my-2">
                <b-form-group :label="this.$t('whistleblowerReport.levelOfAnonymity')">
                  <error-list :field="$v.whistleblowerreport.anonymous_to_company"></error-list>
                  <b-form-radio
                    v-model="$v.whistleblowerreport.anonymous_to_company.$model"
                    value="1"
                    name="some-radios"
                    :disabled="disableFields"
                    ref="whistleblowerreport.anonymous_to_company"
                  >
                    {{ $t("whistleblowerReport.completlyAnonymous") }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="whistleblowerreport.anonymous_to_company"
                    value="2"
                    name="some-radios"
                    :disabled="disableFields"
                  >
                    {{ $t("whistleblowerReport.contactInformationOnlyVisibleToReceiver") }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="whistleblowerreport.anonymous_to_company"
                    value="3"
                    name="some-radios"
                    :disabled="disableFields"
                  >
                    <div v-if="company">
                      {{
                        $t("whistleblowerReport.contactInformationVisibleToCompanyAndReceiver", {
                          company: this.company.name
                        })
                      }}
                    </div>
                    <div v-else>
                      {{
                        $t("whistleblowerReport.contactInformationVisibleToCompanyAndReceiver", {
                          company: "Company being reported"
                        })
                      }}
                    </div>
                  </b-form-radio>
                  <b-form-radio
                    v-model="whistleblowerreport.anonymous_to_company"
                    value="4"
                    name="some-radios"
                    :disabled="disableFields"
                  >
                    <div v-if="company">
                      {{ $t("whistleblowerReport.callInReportViaPhone") }}
                    </div>
                    <div v-else>
                      {{
                        $t("whistleblowerReport.contactInformationVisibleToCompanyAndReceiver", {
                          company: "Company being reported"
                        })
                      }}
                    </div>
                  </b-form-radio>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
          <b-card-text v-if="whistleblowerreport.anonymous_to_company != 4">
            <b-row class="my-2">
              <b-col md="12" class="mb-2 text-center">
                <strong>{{ $t("whistleblowerReport.rememberToDescribeAccurate") }}</strong>
                <br />
                {{ $t("whistleblowerReport.doNotIncludeSensitiveDataUnnecessarily") }}
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col md="12" class="mb-2">
                <strong>
                  {{ $t("whistleblowerReport.report.whatAndWhy") }}
                </strong>
                <b-form-textarea
                  id="textarea"
                  v-model="whistleblowerreport.what_and_why"
                  placeholder
                  rows="2"
                  max-rows="10"
                  :disabled="disableFields"
                ></b-form-textarea>
                <error-list :field="$v.whistleblowerreport.what_and_why" :whistleblower="true"></error-list>
              </b-col>
              <b-col md="6" class="my-2">
                <strong>
                  {{ $t("whistleblowerReport.report.howInfo") }}
                </strong>
                <b-form-textarea
                  id="whistleblowerreport.how_info"
                  v-model="whistleblowerreport.how_info"
                  placeholder
                  rows="2"
                  max-rows="10"
                  :disabled="disableFields"
                  ref="whistleblowerreport.how_info"
                ></b-form-textarea>
                <error-list :field="$v.whistleblowerreport.how_info" :whistleblower="true"></error-list>
              </b-col>
              <b-col md="6" class="my-2">
                <strong>
                  {{ $t("whistleblowerReport.report.whoInvolved") }}
                </strong>
                <b-form-textarea
                  id="textarea"
                  v-model="whistleblowerreport.who_involved"
                  placeholder
                  rows="2"
                  max-rows="10"
                  :disabled="disableFields"
                ></b-form-textarea>
                <error-list :field="$v.whistleblowerreport.who_involved" :whistleblower="true"></error-list>
              </b-col>
              <b-col md="6" class="my-2">
                <strong>
                  {{ $t("whistleblowerReport.report.whenAlerted") }}
                </strong>
                <b-form-input
                  v-model="whistleblowerreport.when_alerted"
                  type="text"
                  :disabled="disableFields"
                ></b-form-input>
                <error-list :field="$v.whistleblowerreport.when_alerted" :whistleblower="true"></error-list>
              </b-col>
              <b-col md="6" class="my-2">
                <strong>
                  {{ $t("whistleblowerReport.report.timePeriod") }}
                </strong>
                <b-form-input
                  v-model="whistleblowerreport.time_period"
                  type="text"
                  :disabled="disableFields"
                ></b-form-input>
                <error-list :field="$v.whistleblowerreport.time_period" :whistleblower="true"></error-list>
              </b-col>
              <b-col md="12" class="my-2">
                <strong>
                  {{ $t("whistleblowerReport.report.stillOngoing") }}
                </strong>
                <b-form-input
                  v-model="whistleblowerreport.still_ongoing"
                  type="text"
                  ref="field6"
                  :disabled="disableFields"
                ></b-form-input>
                <error-list :field="$v.whistleblowerreport.still_ongoing" :whistleblower="true"></error-list>
              </b-col>
              <b-col md="6" class="my-2">
                <strong>
                  {{ $t("whistleblowerReport.report.morePeopleAware") }}
                </strong>
                <b-form-input
                  v-model="whistleblowerreport.more_people_aware"
                  type="text"
                  :disabled="disableFields"
                ></b-form-input>
                <error-list :field="$v.whistleblowerreport.more_people_aware" :whistleblower="true"></error-list>
              </b-col>
              <b-col md="6" class="my-2">
                <strong>
                  {{ $t("whistleblowerReport.report.documentationExists") }}
                </strong>
                <b-form-input
                  v-model="whistleblowerreport.documentation_exists"
                  type="text"
                  :disabled="disableFields"
                ></b-form-input>
                <error-list :field="$v.whistleblowerreport.documentation_exists" :whistleblower="true"></error-list>
                <p class="mb-n1">
                  {{ $t("whistleblowerReport.report.documents") }}
                </p>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col md="12">
                <strong>{{ $tc("other") }}</strong>
                ({{ $t("whistleblowerReport.report.other") }})
                <b-form-textarea
                  id="textarea"
                  v-model="whistleblowerreport.other"
                  placeholder
                  rows="2"
                  max-rows="10"
                  :disabled="disableFields"
                ></b-form-textarea>
                <error-list :field="$v.whistleblowerreport.other" :whistleblower="true"></error-list>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col md="12" class="my-2">
                <document-list
                  :anonymousUpload="true"
                  :documents="whistleblowerreport.documents"
                  :disabled="disableFields"
                />
              </b-col>
            </b-row>
            <br />
            <b-row class="my-2" v-if="whistleblowerreport.anonymous_to_company == 1 && !whistleblowerreport.guid">
              <b-col md="12" class="my-2">
                <h5>{{ $t("whistleblowerReport.loginInfo") }}</h5>
              </b-col>
              <b-col md="6" class="my-2">
                <p>{{ $t("whistleblowerReport.enterAPassword") }}</p>
                <input
                  v-model="whistleblowerreport.password"
                  type="password"
                  id="enterpasswordhere@#$^%"
                  class="form-control"
                  :placeholder="$t('password')"
                  v-if="!whistleblowerreport.guid"
                  ref="whistleblowerreport.password"
                  autocomplete="new-password"
                />
                <error-list :field="$v.whistleblowerreport.password" :whistleblower="true"></error-list>
              </b-col>
              <b-col md="6" class="my-2 password">
                <p>{{ $t("whistleblowerReport.enterAPassword") }}</p>
                <input
                  v-model="spamBotBaitPassword"
                  type="password"
                  id="password"
                  class="form-control password"
                  :placeholder="$t('password')"
                  v-if="!whistleblowerreport.guid"
                  ref="whistleblowerreport.password"
                  autocomplete="new-password"
                />
                <error-list :field="$v.whistleblowerreport.password" :whistleblower="true"></error-list>
              </b-col>
            </b-row>
            <b-row class="my-2" v-if="whistleblowerreport.anonymous_to_company > 1">
              <b-col md="12" class="my-2">
                <h5>{{ $t("whistleblowerReport.loginInfo") }}</h5>
              </b-col>
              <b-col md="6" class="my-2">
                <p>{{ $t("whistleblowerReport.enterAPassword") }}</p>
                <input
                  v-model="whistleblowerreport.password"
                  type="password"
                  id="enterpasswordhere@#$^%"
                  class="form-control"
                  :placeholder="$t('password')"
                  v-if="!whistleblowerreport.guid"
                  ref="whistleblowerreport.password"
                  autocomplete="new-password"
                />
                <error-list :field="$v.whistleblowerreport.password"></error-list>
              </b-col>
              <b-col md="6" class="my-2 password">
                <p>{{ $t("whistleblowerReport.enterAPassword") }}</p>
                <input
                  v-model="spamBotBaitPassword"
                  type="password"
                  id="password"
                  class="form-control password"
                  :placeholder="$t('password')"
                  v-if="!whistleblowerreport.guid"
                  ref="whistleblowerreport.password"
                  autocomplete="new-password"
                />
                <error-list :field="$v.whistleblowerreport.password"></error-list>
              </b-col>
              <b-col md="6">
                <b-col md="12" class="my-2">
                  <strong>
                    {{ $t("name") }}
                  </strong>
                  <b-form-input v-model="whistleblowerreport.name" type="text" :disabled="disableFields"></b-form-input>
                  <error-list :field="$v.whistleblowerreport.name"></error-list>
                </b-col>
                <b-col md="12" class="my-2">
                  <strong>
                    {{ $t("phone") }}
                  </strong>
                  <b-form-input
                    v-model="whistleblowerreport.phone"
                    type="text"
                    :disabled="disableFields"
                  ></b-form-input>
                  <error-list :field="$v.whistleblowerreport.phone"></error-list>
                </b-col>
                <b-col md="12" class="my-2">
                  <strong>
                    {{ $t("email") }}
                  </strong>
                  <b-form-input
                    v-model="whistleblowerreport.email"
                    type="text"
                    :disabled="disableFields"
                  ></b-form-input>
                  <error-list :field="$v.whistleblowerreport.email"></error-list>
                </b-col>
              </b-col>
            </b-row>
            <b-row class="my-2" v-if="whistleblowerreport.anonymous_to_company > 0"></b-row>
            <b-col md="12" class="my-2">
              <pw-button
                v-if="!whistleblowerreport.guid"
                id="login"
                class="my-3 ml-3"
                className="success"
                @accepted="sendReport()"
                :disabled="disableFields"
              >
                <span class="icon">
                  <i class="fa fa-paper-plane mr-2"></i>
                  {{ $t("whistleblowerReport.submitReport") }}
                </span>
              </pw-button>
            </b-col>
          </b-card-text>
          <b-card-text v-if="whistleblowerreport.anonymous_to_company == 4">
            <b-row class="my-2">
              <b-col md="12" class="mb-2 text-center">
                <b>{{ $t("whistleblowerReport.callInReportViaPhoneText") }}</b>
                <h3>{{ this.company.whistleblower_partner.phone }}</h3>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="reportSent">
      <b-col md="12">
        <div class="auth-page">
          <div class="widget-auth mx-auto text-center">
            {{ $t("whistleblowerReport.yourIdIs") }}:
            <h3>{{ this.whistleblowerreport.guid }}</h3>
            <h4>{{ $t("whistleblowerReport.thankYouForYourReport") }}</h4>
            <h4>
              <i>{{ $t("whistleblowerReport.storeThisId") }}</i>
            </h4>
            {{ $t("whistleblowerReport.feelFreeToCheckBackInAFewDays") }}
            <br />
            {{ $t("whistleblowerReport.closeTheBrowser") }}
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DocumentList from "@/components/DocumentList";
import WhistleBlowerReport from "@/models/WhistleBlowerReport";
import WhistleBlowerReportService from "@/services/WhistleBlowerReportService";
import CompanyService from "@/services/CompanyService";

export default {
  name: "WhistleBlowerReportView",
  data() {
    return {
      info: {
        field1: "",
        documents: []
      },
      tabIndex: 0,
      reportSent: false,
      whistleblowerreport: new WhistleBlowerReport({}),
      company: null,
      anonymous_to_company: 0,
      editFields: false,
      error: "",
      spamBotBaitPassword: "",
      companyList: []
    };
  },
  props: {
    whistleblowerReport: {
      type: Object
    },
    manualInvestigatorReport: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  components: {
    DocumentList
  },
  validations: {
    whistleblowerreport: WhistleBlowerReport.validations
  },
  computed: {
    ...mapGetters("constants", ["whistleblowerreportStatusTypes"]),
    disableFields() {
      return !this.editFields;
    }
  },
  mounted() {
    //only fetch these details if the form is not being manually being created by an investigator, because if an investigator is making the report, then they should set the
    //company themselves
    if (this.manualInvestigatorReport == false) {
      //set local whistleblowerreport equal to prop received from successful login attempt
      this.getReport();
      this.getCompanybyWhistleblowerReference(this.$route.params.id);
    } else if (this.manualInvestigatorReport == true) {
      this.editFields = true;
      CompanyService.getCompanies().then((companies) => {
        //filter and only return companies that have the investigator user's company as a whistleblower partner
        this.companyList = companies.filter(
          (item) => item.whistleblower_partner != null && item.whistleblower_partner.id == this.$user.company.id
        );
      });
    }
  },
  methods: {
    getReport() {
      if (this.$route.name == "whistleblowerlogin") {
        this.whistleblowerreport = this.whistleblowerReport;
        return;
      }
      this.editFields = true;
    },
    sendReport() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.error = "There are required fields outstanding";
        window.scrollTo(0, 0);
        return;
      }
      if (this.spamBotBaitPassword.length > 0) {
        this.reportSent = true;
        return;
      }
      //if regular anonymous reporter send to one end point
      if (this.manualInvestigatorReport == false) {
        WhistleBlowerReportService.createReport(this.whistleblowerreport).then((whistleblowerreport) => {
          this.whistleblowerreport.guid = whistleblowerreport.guid;
          this.reportSent = true;
        });
      }
      //else if investigator creating a manual report, send to another end point
      else if (this.manualInvestigatorReport == true) {
        WhistleBlowerReportService.createManualReport(this.whistleblowerreport).then((whistleblowerreport) => {
          this.whistleblowerreport.guid = whistleblowerreport.guid;
          this.reportSent = true;
        });
      }
    },
    getCompanybyWhistleblowerReference(id) {
      CompanyService.getCompanybyWhistleblowerReference(id).then((company) => {
        this.company = company;
        this.whistleblowerreport.company = this.company;
      });
    }
  }
};
</script>
<style scoped lang="scss">
.password {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
}
</style>
